import { Box, Button, useMediaQuery, useTheme } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useWeb3React } from "@web3-react/core";
import { tokens } from "../../theme";
import FilterBox from "./components/FilterBox";
import ProfileLayout from "../global/ProfileLayout";

import TableView from "./components/TableView";
import styled from "@emotion/styled";
import { NftCard } from "../../components/NftCard";
import { useTypedSelector } from "../../hooks/useTypedSelector";
import { useUIActions } from "../../hooks/useActions";
import { SelectedNftStep } from "./components/SelectedNftStep";
import { SearchAndView } from "./components/SearchAndView";
import FinalPreview from "./components/FinalPreview";
import { NoData } from "../../components/NoData";
import { useParams } from "react-router-dom";
import { getContractMetadata } from "../../state/action-creators/APIActionCreators";

const StyledButton = styled(Button)(({ theme, colors }) => ({
  backgroundColor: colors.whiteAccent[900],
  color: colors.primary[500],
  fontSize: "14px",
  fontWeight: 400,
  width: "272px",
  height: "40px",
  borderRadius: "7px",
  borderColor: colors.primary[500],
  marginLeft: "20px",
  "&:hover": {
    backgroundColor: colors.primary[600],
    borderColor: colors.primary[500],
    color: colors.whiteAccent[900],
  },
}));

const Profile = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const { account } = useWeb3React();
  const { address } = useParams();
  const downXl = useMediaQuery(theme.breakpoints.down("xl"));
  const downMd = useMediaQuery(theme.breakpoints.down("md"));

  const { setSnackbar } = useUIActions();
  const [collapsed, setCollapsed] = useState(false);
  const [view, setView] = useState("gallery");
  // const profileNftsFromRedux = useTypedSelector(
  //   (state) => state.apiReducer.profileNfts
  // );
  const profileNftsFromRedux = useTypedSelector(
    (state) => state.apiReducer.collectionWiseProfileNfts
  );
  const [profileNfts, setProfileNfts] = useState([]);

  const [searchVar, setSearchVar] = useState("");
  const [searchShow, setSearchShow] = useState(false);
  const [filteredNfts, setFilteredNfts] = useState([]);

  const [collectionAddress, setCollectionAddress] = useState("");
  const [step, setStep] = useState(0);
  const [operation, setOperation] = useState("bulk-lend");

  const [currentInstance, setCurrentInstance] = useState(0);
  const [droppedNfts, setDroppedNfts] = useState([]);
  const [scholarAddress, setScholarAddress] = useState("");
  const [split, setSplit] = useState("");
  const [selectedNft, setSelectedNft] = useState(
    profileNfts.filter((nftP) => nftP.selected)
  );
  const [type, setType] = useState("ERC721");

  console.log("resp in useef out", type);

  console.log("profileNftsFromRedux 1", profileNfts);

  useEffect(() => {
    // if (updNfts.length > 0)
    //   setType(
    //     profileNftsFromRedux.filter(
    //       (collection) => collection.address === address
    //     )[0]?.contractMetadata?.tokenType
    //   );

    if (
      profileNftsFromRedux.length > 0 &&
      profileNftsFromRedux.filter(
        (collection) => collection.address === address
      ).length > 0
    ) {
      setProfileNfts(
        profileNftsFromRedux
          .filter((collection) => collection.address === address)[0]
          .nfts.map((nft) => {
            return { ...nft, selected: false };
          })
      );

      setType(
        profileNftsFromRedux.filter(
          (collection) => collection.address === address
        )[0]?.contractMetadata?.tokenType
      );
    } else {
      setProfileNfts([]);
    }
  }, [JSON.stringify(profileNftsFromRedux)]);

  const instanceEntity = {
    scholarAddress: "",
    rewardTokenAddress: "",
    split: "",
    amount: "",
    droppedNfts: [],
  };

  const instanceGenerator = () => {
    return instanceEntity;
  };

  const [instances, setInstances] = useState([instanceEntity]);

  const addInstance = () => {
    setInstances([...instances, instanceGenerator()]);
  };

  const updateInstance = (index, payload) => {
    let copy = [...instances];
    copy[index] = {
      ...copy[index],
      ...payload,
    };
    setInstances(copy);
  };

  const removeInstance = (index) => {
    let copy = [...instances];
    copy.splice(index, 1);
    setInstances(copy);
  };

  useEffect(() => {
    setSelectedNft(profileNfts.filter((nft) => nft.selected));
  }, [profileNfts]);

  const setNftStaesOnSelect = (
    dataForProfileNfts,
    itemToRemoveFromDroppedNfts
  ) => {
    console.log("inside main", dataForProfileNfts);
    const tempProfileNfts = profileNfts.map((nftP) => {
      if (
        nftP.tokenId === itemToRemoveFromDroppedNfts.tokenId &&
        nftP.nftAddress === itemToRemoveFromDroppedNfts.nftAddress
      ) {
        return { ...nftP, selected: !nftP.selected };
      } else {
        return nftP;
      }
    });
    const tempSelectedNft = tempProfileNfts.filter((nft) => nft.selected);

    console.log(
      "every condition",
      tempSelectedNft,

      tempSelectedNft.every(
        (nft) => nft.selected && collectionAddress === nft.nftAddress
      )
    );

    if (tempProfileNfts.filter((nft) => nft.selected).length === 0) {
      setProfileNfts(tempProfileNfts);
      setSelectedNft([]);
      setCollectionAddress("");
    }

    if (tempProfileNfts.filter((nft) => nft.selected).length === 1) {
      setProfileNfts(tempProfileNfts);
      setSelectedNft(tempProfileNfts.filter((nft) => nft.selected));
      setCollectionAddress(
        tempProfileNfts.filter((nft) => nft.selected)[0].nftAddress
      );
    }

    if (
      tempProfileNfts.filter((nft) => nft.selected).length > 1 &&
      tempSelectedNft.every(
        (nft) => nft.selected && collectionAddress === nft.nftAddress
      )
    ) {
      setProfileNfts(tempProfileNfts);
      setSelectedNft(tempProfileNfts.filter((nft) => nft.selected));
      setCollectionAddress(
        tempProfileNfts.filter((nft) => nft.selected)[0].nftAddress
      );
    }

    if (
      tempProfileNfts.filter((nft) => nft.selected).length > 1 &&
      !tempSelectedNft.every(
        (nft) => nft.selected && collectionAddress === nft.nftAddress
      )
    ) {
      setSnackbar({
        open: true,
        severity: "info",
        message: `Cannot select Nfts other than ${
          tempSelectedNft.filter(
            (nft) => nft.selected && collectionAddress === nft.nftAddress
          )[0].contractName
        } collection`,
      });
    }

    setDroppedNfts(
      droppedNfts.filter(
        (nftD) => nftD.tokenId !== itemToRemoveFromDroppedNfts.tokenId
      )
    );
  };

  const NftBoxProps = () => {
    if (downMd && !collapsed) {
      return {
        display: "grid",
        gridTemplateColumns: "repeat(10, 1fr)",

        gap: "30px",
      };
    } else if (downMd) {
      return {
        display: "grid",
        gridTemplateColumns: "repeat(15, 1fr)",
        gap: "30px",
      };
    } else if (downXl && !collapsed) {
      return {
        display: "grid",
        gridTemplateColumns: "repeat(15, 1fr)",
        gap: "30px",
      };
    } else if (downXl || !collapsed) {
      return {
        display: "grid",
        gridTemplateColumns: "repeat(20, 1fr)",
        gap: "30px",
      };
    } else {
      return {
        display: "grid",
        gridTemplateColumns: "repeat(25, 1fr)",
        gap: "30px",
      };
    }
  };

  console.log("new states", { currentInstance, instances });

  if (step === 1) {
    return (
      <SelectedNftStep
        selectedNft={profileNfts}
        setSelectedNft={setSelectedNft}
        setProfileNfts={setProfileNfts}
        setStep={setStep}
        operation={operation}
        droppedNfts={droppedNfts}
        setDroppedNfts={setDroppedNfts}
        scholarAddress={scholarAddress}
        setScholarAddress={setScholarAddress}
        split={split}
        setSplit={setSplit}
        currentInstance={currentInstance}
        setCurrentInstance={setCurrentInstance}
        instances={instances}
        addInstance={addInstance}
        updateInstance={updateInstance}
        removeInstance={removeInstance}
        setInstances={setInstances}
        type={type}
      />
    );
  }
  if (step === 0) {
    return (
      <ProfileLayout
        FilterBox={() => (
          <FilterBox collapsed={collapsed} setCollapsed={setCollapsed} />
        )}
        collectionCount={false}
        nftCount={false}
      >
        <Box
          sx={{
            width: "100%",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            justifyContent: "flex-start",
            paddingBottom: "20px",
          }}
          gap="10px"
        >
          <SearchAndView
            view={view}
            setView={setView}
            searchVar={searchVar}
            setFiltered={(e) => {
              const { value } = e.target;
              setSearchVar(value);
              if (value === "") {
                setSearchShow(false);
                setFilteredNfts([]);
              } else {
                const filtered = profileNfts.filter((nft) =>
                  nft.name.toLowerCase().includes(value.toLowerCase())
                );

                setFilteredNfts(filtered);
                setSearchShow(true);
              }
            }}
          />

          {searchShow && filteredNfts.length > 0 ? (
            view === "gallery" ? (
              <Box {...NftBoxProps()}>
                {filteredNfts.map((item, index) => (
                  <Box gridColumn="span 5" gridRow="span 3">
                    <NftCard
                      image={item.image}
                      collectionName={item.contractName}
                      name={item.name}
                      tokenId={item.tokenId}
                      status={item.status}
                      address={item.nftAddress}
                      key={index}
                      index={index}
                      currNft={item}
                      profileNfts={filteredNfts}
                      setFilteredNfts={setFilteredNfts}
                      setNftStaesOnSelect={setNftStaesOnSelect}
                    />
                  </Box>
                ))}
              </Box>
            ) : (
              <TableView
                data={filteredNfts}
                setFilteredNfts={setFilteredNfts}
                setNftStaesOnSelect={setNftStaesOnSelect}
              />
            )
          ) : searchShow && filteredNfts.length === 0 ? (
            <Box
              sx={{
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginTop: "20px",
              }}
            >
              <NoData text="No Nft to show!" />
            </Box>
          ) : profileNfts.length > 0 ? (
            view === "gallery" ? (
              <Box {...NftBoxProps()}>
                {profileNfts.map((item, index) => (
                  <Box gridColumn="span 5" gridRow="span 3">
                    <NftCard
                      image={item.image}
                      collectionName={item.contractName}
                      name={item.name}
                      tokenId={item.tokenId}
                      status={item.status}
                      address={item.nftAddress}
                      key={index}
                      index={index}
                      currNft={item}
                      profileNfts={profileNfts}
                      setNftStaesOnSelect={setNftStaesOnSelect}
                    />
                  </Box>
                ))}
              </Box>
            ) : (
              <TableView
                data={profileNfts}
                setNftStaesOnSelect={setNftStaesOnSelect}
              />
            )
          ) : (
            <Box
              sx={{
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginTop: "20px",
              }}
            >
              <NoData text="No Nft to show!" />
            </Box>
          )}

          <Box
            display="flex"
            flexDirection="row"
            width="97%"
            marginBottom="10px"
            marginTop="50px"
            alignItems={"center"}
            justifyContent={"center"}
            pl={1}
          >
            <StyledButton
              onClick={() => {
                setStep(1);
                setOperation("bulk-lend");
              }}
              variant="outlined"
              colors={colors}
              disabled={selectedNft.length === 0}
            >
              Yield Split
            </StyledButton>

            <StyledButton
              onClick={() => {
                setStep(1);
                setOperation("bulk-transfer");
              }}
              variant="outlined"
              colors={colors}
              disabled={selectedNft.length === 0}
            >
              Send
            </StyledButton>
          </Box>
        </Box>
      </ProfileLayout>
    );
  }
};

export default Profile;
